import type { ReactNode } from 'react';
import { Button, type ButtonProps } from '@/shared/ui/button';
import { Tooltip } from '@/shared/ui/tooltip';

interface ActionIconButtonProps extends Omit<ButtonProps, 'children'> {
  label: string;
  children: ReactNode;
  copyText?: string;
}

/** Botão de ícone com tooltip explicativo (ações em cards e tabelas). */
export function ActionIconButton({ label, children, className, copyText, ...props }: ActionIconButtonProps) {
  return (
    <Tooltip content={label} side="top" copyText={copyText} interactive={!!copyText}>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className={className}
        aria-label={label}
        {...props}
      >
        {children}
      </Button>
    </Tooltip>
  );
}

interface ActionIconLinkProps {
  label: string;
  href: string;
  children: ReactNode;
  className?: string;
  copyText?: string;
}

export function ActionIconLink({ label, href, children, className, copyText }: ActionIconLinkProps) {
  return (
    <Tooltip content={label} side="top" copyText={copyText ?? href} interactive>
      <Button variant="ghost" size="icon" className={className} asChild>
        <a href={href} target="_blank" rel="noreferrer" aria-label={label}>
          {children}
        </a>
      </Button>
    </Tooltip>
  );
}
